'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (Component) {
  return Component.displayName || Component.name || 'Component';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-jss/lib/getDisplayName.js
// module id = 1321
// module chunks = 168707334958949